import Vue from "vue";
import "@/default/shares";
import "@/default/services";

import AdminActivity from "@/default/pages/admins/activity.vue";
import ActionLogs from "@/default/pages/action_logs/logs.vue";
import ActionLogStats from "@/default/pages/action_logs/stats.vue";
import CategorySetting from "@/default/pages/categories/settings.vue";
import CategoryPaycheckRatio from "@/default/pages/categories/paycheck_ratio.vue";
import SystemSetting from "@/default/pages/system_settings/base.vue";
import Unlocode from "@/default/pages/unlocode.vue";

import TripPlans from "@/default/pages/trip_plans.vue";
import CompanyAccount from "@/default/pages/companies/account.vue";
import CompanyDetail from "@/default/pages/companies/detail.vue";
import CompanyMerger from "@/default/pages/companies/merger.vue";
import IntermodalNetworks from "@/default/pages/intermodal/networks.vue";
import AlterRequest from "@/default/pages/alter_request.vue";
import AvailStats from "@/default/pages/avail_stats.vue";
import EquipmentHistory from "@/default/pages/equipment_history.vue";
import QuickSearch from "@/default/pages/quick_search.vue";
import ThirdPartyItem from "@/default/pages/third_party_item.vue";
import Reconciliation from "@/default/pages/reconciliation.vue";
import ChassisFee from "@/default/pages/chassis_fee.vue";
import DailyCost from "@/default/pages/daily_cost.vue";
import FreeOut from "@/default/pages/free_out.vue";
import FinancialPerformance from "@/default/pages/financials/performance.vue";
import FinancialBalanceSheet from "@/default/pages/financials/balance_sheet.vue";
import FinancialProfitLoss from "@/default/pages/financials/profit_loss.vue";
import FinancialStatements from "@/default/pages/financials/financial-statements.vue";
import BankStatementWidget from "@/default/pages/banks/statements/widget.vue";
import TraceWidget from "@/default/pages/traces/widget.vue";
import Avatar from "@/default/pages/avatar.vue";
import Dropzone from "@/default/pages/dropzone.vue";
import Scanner from "@/default/pages/scanner.vue";
import Uploader from "@/default/pages/uploader.vue";
import ImportTable from "@/default/pages/imports/table.vue";

import AdvanceWidget from "@/default/pages/advances/widget.vue";
import BankTransferWidget from "@/default/pages/bank_transfers/widget.vue";
import NoteEntry from "@/default/pages/notes/entry.vue";
import NoteWidget from "@/default/pages/notes/widget.vue";
import NoteUnread from "@/default/pages/notes/unread.vue";
import NoteReport from "@/default/pages/notes/report.vue";
import TicketBoard from "@/default/pages/tickets/board.vue";
import ImageInbox from "@/default/pages/images/inbox.vue";
import ImageUploader from "@/default/pages/images/uploader.vue";
import ImageShares from "@/default/pages/images/shares.vue";
import TextractWidget from "@/default/pages/textract/widget.vue";

import CheckMarker from "@/default/pages/check_marker.vue";

import ChargeForm from "@/default/pages/charges/form.vue";
import ChargeAllocation from "@/default/pages/charges/allocation.vue";

import CalendarHoliday from "@/default/pages/calendars/holiday.vue";
import CalendarAttendance from "@/default/pages/calendars/attendance.vue";

import Tasks from "@/default/pages/tasks/tasks.vue";
import TaskPopup from "@/default/pages/tasks/popup.vue";
import TaskWidget from "@/default/pages/tasks/widget.vue";
import TaskChecks from "@/default/pages/tasks/checks.vue";
import TaskConnector from "@/default/pages/tasks/connector.vue";

import OrderWidget from "@/default/pages/order_widget.vue";

import ContainerLock from "@/default/pages/containers/lock.vue";
import ContainerHub from "@/default/pages/containers/hub.vue";
import ContainerViewer from "@/default/pages/containers/viewer.vue";
import ContainerDocuments from "@/default/pages/containers/documents.vue";
import ContainerAppointment from "@/default/pages/containers/appointment.vue";
import ContainerEta from "@/default/pages/containers/eta.vue";
import ContainerApptConfirm from "@/default/pages/containers/appt_confirm.vue";
import ContainerHazardous from "@/default/pages/containers/hazardous.vue";
import ContainerTank from "@/default/pages/containers/tank.vue";
import ContainerOpentrack from "@/default/pages/containers/opentrack.vue";
import ContainerGnosis from "@/default/pages/containers/gnosis.vue";
import ContainerPriority from "@/default/pages/containers/priority.vue";
import ContainerColorify from "@/default/pages/containers/colorify.vue";
import ContainerOrderType from "@/default/pages/containers/order_type.vue";
import ContainerVendor from "@/default/pages/containers/vendor.vue";
import ContainerRefresher from "@/default/pages/containers/refresher.vue";
import ContainerScales from "@/default/pages/containers/scales.vue";
import ContainerDispatchStats from "@/default/pages/containers/dispatch_stats.vue";
import ContainerRoutes from "@/default/pages/containers/routes.vue";
import ContainerOperations from "@/default/pages/containers/operations.vue";
import ContainerInterchanges from "@/default/pages/containers/interchanges.vue";
import ContainerInterchangeAction from "@/default/pages/containers/interchange_action.vue";
import ContainerMailings from "@/default/pages/containers/mailings.vue";
import ContainerDeviation from "@/default/pages/containers/deviation.vue";
import ContainerReplica from "@/default/pages/containers/replica.vue";
import ContainerDispatch from "@/default/pages/containers/dispatch.vue";
import ContainerTransport from "@/default/pages/containers/transport.vue";
import ContainerTransportCompact from "@/default/pages/containers/transport_compact.vue";
import ContainerTransportViewer from "@/default/pages/containers/transport_viewer.vue";
import ContainerTransportTasks from "@/default/pages/containers/transport_tasks.vue";
import ContainerCalendar from "@/default/pages/containers/calendar/index.vue";
import ContainerPreAlert from "@/default/pages/containers/pre_alert/index.vue";
import ContainerPrePulls from "@/default/pages/containers/pre_pulls.vue";
import ContainerOrderStack from "@/default/pages/containers/order_stack/index.vue";
import ContainerOrderStatus from "@/default/pages/containers/order_status/index.vue";
import ContainerWildSearch from "@/default/pages/containers/wild_search/index.vue";
import ContainerBrief from "@/default/pages/containers/brief.vue";
import ContainerAudit from "@/default/pages/containers/audit.vue";
import ContainerStreetTurn from "@/default/pages/containers/street_turn.vue";
import ContainerNotifiedAt from "@/default/pages/containers/notified_at.vue";
import ContainerTasks from "@/default/pages/containers/tasks.vue";
import ContainerWarehouse from "@/default/pages/containers/warehouse/index.vue";
import ContainerProfits from "@/default/pages/containers/profits.vue";
import ContainerStatsChassisSplit from "@/default/pages/containers/stats/chassis_split.vue";
import ContainerCommunications from "@/default/pages/containers/communications/index.vue";

import CarrierItemFlow from "@/default/pages/carrier_items/flow.vue";

import Dispatches from "@/default/pages/dispatches/index.vue";
import ChassisOrders from "@/default/pages/chassis/orders.vue";
import BrokerOrders from "@/default/pages/brokers/orders.vue";
import BrokerIcon from "@/default/pages/brokers/icon.vue";

import TransactionBasic from "@/default/pages/transactions/basic.vue";

import OperationAppt from "@/default/pages/operations/appt.vue";
import OperationTime from "@/default/pages/operations/time.vue";
import OperationPin from "@/default/pages/operations/pin.vue";
import OperationApmAppointment from "@/default/pages/operations/apm_appointment.vue";

import Truckload from "@/default/pages/truckload.vue";
import LtlForm from "@/default/pages/ltls/form.vue";
import TlForm from "@/default/pages/tls/form.vue";
import BolForm from "@/default/pages/bols/form.vue";
import BolTrips from "@/default/pages/bols/trips.vue";

import RouteWarning from "@/default/pages/routes/warning.vue";

import CustomerPerformance from "@/default/pages/customers/performance.vue";
import ContactProfile from "@/default/pages/contacts/profile.vue";
import ContactOrders from "@/default/pages/contacts/orders.vue";
import ContactQuotes from "@/default/pages/contacts/quotes.vue";

import ApplicantOwner from "@/default/pages/applicants/owner.vue";
import DriverActivity from "@/default/pages/drivers/activity.vue";
import DriverPane from "@/default/pages/drivers/pane.vue";
import DriverDuty from "@/default/pages/drivers/duty.vue";
import DriverReview from "@/default/pages/drivers/review.vue";
import DriverPerformance from "@/default/pages/drivers/performance.vue";
import DriverPreferred from "@/default/pages/drivers/preferred.vue";
import DriverPremium from "@/default/pages/drivers/premium/index.vue";
import DriverPaycheck from "@/default/pages/drivers/paycheck.vue";
import DriverNoLoad from "@/default/pages/drivers/no_load.vue";
import DriverHosLogs from "@/default/pages/drivers/hos_logs.vue";
import DriverOperators from "@/default/pages/drivers/operators.vue";
import DriverMap from "@/default/pages/drivers/map.vue";

import TruckMerger from "@/default/pages/trucks/merger.vue";

import InvoiceForm from "@/default/pages/invoices/form.vue";
import InvoiceTpForm from "@/default/pages/invoices/tp_form.vue";
import InvoiceCompany from "@/default/pages/invoices/company.vue";

import BaseRateInit from "@/default/pages/base_rates/init.vue";
import BaseRateWidget from "@/default/pages/base_rates/widget.vue";
import BaseRateHub from "@/default/pages/base_rates/hub.vue";
import BaseRateChart from "@/default/pages/base_rates/chart.vue";
import BaseRateQuicker from "@/default/pages/base_rates/quicker.vue";
import CustomerRateQuicker from "@/default/pages/base_rates/customer.vue";
import DriverRateQuicker from "@/default/pages/base_rates/driver.vue";

import QuoteEngineWidget from "@/default/pages/quote_engines/widget.vue";
import MapAddress from "@/default/pages/maps/address.vue";
import MapRoutes from "@/default/pages/maps/routes.vue";
import MapMarker from "@/default/pages/maps/marker.vue";
import MapFence from "@/default/pages/maps/fence.vue";
import MapSuggest from "@/default/pages/maps/suggest.vue";
import EdiLogs from "@/default/pages/edi/logs/index.vue";
import DocumentSignaturePdf from "@/default/pages/document_signatures/pdf.vue";

import Suppressions from "@/default/pages/suppressions/index.vue";

import Signup from "@/default/pages/signups/start.vue";

import Modalmatch from "@/default/pages/modalmatch/main.vue";
import XMap from "@/default/pages/xmap/main.vue";

import ChatPopup from "@/default/pages/chats/popup.vue";
import Workspace from "@/default/pages/workspace/widget.vue";

import RewardsLedger from "@/default/pages/rewards/ledger.vue";
import RewardsPool from "@/default/pages/rewards/pool.vue";
import QuickbooksExport from "@/default/pages/quickbooks/export.vue";

import CarrierPane from "@/default/pages/carriers/pane.vue";
import CarrierStats from "@/default/pages/carriers/stats.vue";
import CarriersBroker from "@/default/pages/carriers/broker.vue";
import CarriersBrokerQuotes from "@/default/pages/carriers/brokers/quotes.vue";

import AiAgentWidget from "@/default/pages/ai/agent/widget.vue";
import AiAgentTarget from "@/default/pages/ai/agent/target.vue";

Vue.component("admin-activity", AdminActivity);
Vue.component("action-logs", ActionLogs);
Vue.component("action-log-stats", ActionLogStats);
Vue.component("category-setting", CategorySetting);
Vue.component("category-paycheck-ratio", CategoryPaycheckRatio);
Vue.component("system-setting", SystemSetting);
Vue.component("unlocode", Unlocode);

Vue.component("trip-plans", TripPlans);
Vue.component("company-account", CompanyAccount);
Vue.component("company-detail", CompanyDetail);
Vue.component("company-merger", CompanyMerger);
Vue.component("intermodal-networks", IntermodalNetworks);
Vue.component("alter-request", AlterRequest);
Vue.component("avail-stats", AvailStats);
Vue.component("equipment-history", EquipmentHistory);
Vue.component("quick-search", QuickSearch);
Vue.component("third-party-item", ThirdPartyItem);
Vue.component("reconciliation", Reconciliation);
Vue.component("chassis-fee", ChassisFee);
Vue.component("daily-cost", DailyCost);
Vue.component("free-out", FreeOut);
Vue.component("financial-performance", FinancialPerformance);
Vue.component("financial-balance-sheet", FinancialBalanceSheet);
Vue.component("financial-profit-loss", FinancialProfitLoss);
Vue.component("financial-statements", FinancialStatements);
Vue.component("bank-statement-widget", BankStatementWidget);
Vue.component("trace-widget", TraceWidget);
Vue.component("avatar", Avatar);
Vue.component("dropzone", Dropzone);
Vue.component("scanner", Scanner);
Vue.component("uploader", Uploader);
Vue.component("import-table", ImportTable);

Vue.component("check-marker", CheckMarker);

Vue.component("charge-form", ChargeForm);
Vue.component("charge-allocation", ChargeAllocation);

Vue.component("advance-widget", AdvanceWidget);
Vue.component("bank-transfer-widget", BankTransferWidget);

Vue.component("note-entry", NoteEntry);
Vue.component("note-widget", NoteWidget);
Vue.component("note-report", NoteReport);
Vue.component("note-unread", NoteUnread);

Vue.component("ticket-board", TicketBoard);

Vue.component("image-inbox", ImageInbox);
Vue.component("image-uploader", ImageUploader);
Vue.component("image-shares", ImageShares);

Vue.component("textract-widget", TextractWidget);

Vue.component("calendar-holiday", CalendarHoliday);
Vue.component("calendar-attendance", CalendarAttendance);
Vue.component("tasks", Tasks);
Vue.component("task-popup", TaskPopup);
Vue.component("task-widget", TaskWidget);
Vue.component("task-checks", TaskChecks);
Vue.component("task-connector", TaskConnector);

Vue.component("order-widget", OrderWidget);
Vue.component("container-lock", ContainerLock);
Vue.component("container-hub", ContainerHub);
Vue.component("container-documents", ContainerDocuments);
Vue.component("container-viewer", ContainerViewer);
Vue.component("container-appointment", ContainerAppointment);
Vue.component("container-eta", ContainerEta);
Vue.component("container-appt-confirm", ContainerApptConfirm);
Vue.component("container-hazardous", ContainerHazardous);
Vue.component("container-tank", ContainerTank);
Vue.component("container-opentrack", ContainerOpentrack);
Vue.component("container-gnosis", ContainerGnosis);
Vue.component("container-priority", ContainerPriority);
Vue.component("container-colorify", ContainerColorify);
Vue.component("container-order-type", ContainerOrderType);
Vue.component("container-vendor", ContainerVendor);
Vue.component("container-refresher", ContainerRefresher);
Vue.component("container-scales", ContainerScales);
Vue.component("container-dispatch-stats", ContainerDispatchStats);
Vue.component("container-routes", ContainerRoutes);
Vue.component("container-operations", ContainerOperations);
Vue.component("container-interchanges", ContainerInterchanges);
Vue.component("container-interchange-action", ContainerInterchangeAction);
Vue.component("container-mailings", ContainerMailings);
Vue.component("container-deviation", ContainerDeviation);
Vue.component("container-replica", ContainerReplica);
Vue.component("container-dispatch", ContainerDispatch);
Vue.component("container-transport", ContainerTransport);
Vue.component("container-transport-compact", ContainerTransportCompact);
Vue.component("container-transport-viewer", ContainerTransportViewer);
Vue.component("container-transport-tasks", ContainerTransportTasks);
Vue.component("container-calendar", ContainerCalendar);
Vue.component("container-pre-alert", ContainerPreAlert);
Vue.component("container-pre-pulls", ContainerPrePulls);
Vue.component("container-order-stack", ContainerOrderStack);
Vue.component("container-order-status", ContainerOrderStatus);
Vue.component("container-wild-search", ContainerWildSearch);
Vue.component("container-brief", ContainerBrief);
Vue.component("container-audit", ContainerAudit);
Vue.component("container-street-turn", ContainerStreetTurn);
Vue.component("container-notified-at", ContainerNotifiedAt);
Vue.component("container-tasks", ContainerTasks);
Vue.component("container-warehouse", ContainerWarehouse);
Vue.component("container-profits", ContainerProfits);
Vue.component("container-stats-chassis-split", ContainerStatsChassisSplit);
Vue.component("container-communications", ContainerCommunications);

Vue.component("carrier-item-flow", CarrierItemFlow);

Vue.component("dispatches", Dispatches);

Vue.component("broker-orders", BrokerOrders);
Vue.component("broker-icon", BrokerIcon);

Vue.component("chassis-orders", ChassisOrders);
Vue.component("transaction-basic", TransactionBasic);

Vue.component("operation-appt", OperationAppt);
Vue.component("operation-time", OperationTime);
Vue.component("operation-pin", OperationPin);
Vue.component("operation-apm-appointment", OperationApmAppointment);

Vue.component("truckload", Truckload);
Vue.component("ltl-form", LtlForm);
Vue.component("tl-form", TlForm);
Vue.component("bol-form", BolForm);
Vue.component("bol-trips", BolTrips);

Vue.component("route-warning", RouteWarning);

Vue.component("customer-performance", CustomerPerformance);
Vue.component("contact-profile", ContactProfile);
Vue.component("contact-orders", ContactOrders);
Vue.component("contact-quotes", ContactQuotes);

Vue.component("applicant-owner", ApplicantOwner);
Vue.component("driver-activity", DriverActivity);
Vue.component("driver-pane", DriverPane);
Vue.component("driver-duty", DriverDuty);
Vue.component("driver-review", DriverReview);
Vue.component("driver-paycheck", DriverPaycheck);
Vue.component("driver-performance", DriverPerformance);
Vue.component("driver-preferred", DriverPreferred);
Vue.component("driver-premium", DriverPremium);
Vue.component("driver-no-load", DriverNoLoad);
Vue.component("driver-hos-logs", DriverHosLogs);
Vue.component("driver-operators", DriverOperators);
Vue.component("driver-map", DriverMap);

Vue.component("truck-merger", TruckMerger);

Vue.component("invoice-form", InvoiceForm);
Vue.component("invoice-tp-form", InvoiceTpForm);
Vue.component("invoice-company", InvoiceCompany);

Vue.component("base-rate-init", BaseRateInit);
Vue.component("base-rate-widget", BaseRateWidget);
Vue.component("base-rate-hub", BaseRateHub);
Vue.component("base-rate-chart", BaseRateChart);
Vue.component("base-rate-quicker", BaseRateQuicker);
Vue.component("customer-rate-quicker", CustomerRateQuicker);
Vue.component("driver-rate-quicker", DriverRateQuicker);

Vue.component("quote-engine-widget", QuoteEngineWidget);
Vue.component("map-address", MapAddress);
Vue.component("map-routes", MapRoutes);
Vue.component("map-marker", MapMarker);
Vue.component("map-fence", MapFence);
Vue.component("map-suggest", MapSuggest);
Vue.component("edi-logs", EdiLogs);

Vue.component("document-signature-pdf", DocumentSignaturePdf);

Vue.component("suppressions", Suppressions);

Vue.component("signup", Signup);

Vue.component("modalmatch", Modalmatch);
Vue.component("xmap", XMap);

Vue.component("chat-popup", ChatPopup);
Vue.component("workspace", Workspace);

Vue.component("rewards-ledger", RewardsLedger);
Vue.component("rewards-pool", RewardsPool);
Vue.component("quickbooks-export", QuickbooksExport);

Vue.component("carrier-pane", CarrierPane);
Vue.component("carrier-stats", CarrierStats);
Vue.component("carriers-broker", CarriersBroker);
Vue.component("carriers-broker-quotes", CarriersBrokerQuotes);

Vue.component("ai-agent-widget", AiAgentWidget);
Vue.component("ai-agent-target", AiAgentTarget);
